import React from 'react';
import { Row, Column } from 'components/Layout/Grid';

import logoViveo from 'img/viveo-portal.svg';
import logosEmpresasGrupo from 'img/logos-empresas-grupo.svg';
import { useLocation } from 'react-router-dom';

export const Footer: React.FC = () => {
  const location = useLocation();

  return (
    <Row
      className={`bg-white w-100 align-center align-md-none mt-6 flex-md-column justify-between ${location.pathname === '/carta-correcao' || location.pathname === '/manutencao' ? 'footer' : ''}`}
      style={{ minHeight: 127, borderTop: '1px solid #D3D3D3' }}
    >
      <Row className="pl-8 pl-lg-3 py-md-4 border-md-none w-md-100 d-md-none">
        <img src={logoViveo} alt="logo viveo" style={{ maxWidth: 180, maxHeight: 41 }} />
      </Row>

      <Column className="px-8 px-lg-4 py-md-4 d-md-none">
        <img src={logosEmpresasGrupo} alt="empresas do grupo" style={{ maxWidth: 713, height: 54 }} />
      </Column>

      <Row className="w-md-100 pr-8 pr-lg-3 d-md-none" style={{ width: 40 }} />
    </Row>
  );
};
